import { createFileRoute, redirect } from '@tanstack/react-router'
import { safeFrom } from '~/features/auth/form'
import { LoginPage } from '~/features/auth/LoginPage'
import { configQuery, optionalSession } from '~/features/auth/queries'

export const Route = createFileRoute('/login')({
  validateSearch: (s: Record<string, unknown>): { from?: string } => {
    const from = safeFrom(s.from)
    return from ? { from } : {}
  },
  beforeLoad: async ({ context, search }) => {
    // Already logged in: straight to where the link pointed (v1 showed the form again).
    const session = await optionalSession((q) => context.queryClient.ensureQueryData(q))
    if (session?.active) throw redirect({ href: search.from ?? '/' })
    if (session) throw redirect({ to: '/setup' })
  },
  loader: ({ context }) => void context.queryClient.prefetchQuery(configQuery),
  component: function Login() {
    return <LoginPage from={Route.useSearch().from} />
  },
})
